import React from 'react';

export const ConditionalDataIdWrapper = ({
  dataId,
  children,
}: {
  dataId?: string;
  children: React.ReactElement;
}) => (dataId ? <div data-id={dataId}>{children}</div> : <>{children}</>);
